let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dHjW1")).then(() => parcelRequire('2Bbby'));